import ReactMarkdown from 'react-markdown'
import { withLineBreaks } from './chatText'

// Assistant answers are markdown-lite: paragraphs, lists, bold. A single line
// break becomes a visible break (markdown would otherwise join the lines).
// Raw HTML is never rendered (react-markdown default).
const markdownComponents = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 mb-2 last:mb-0 space-y-1">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 last:mb-0 space-y-1">{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  a: ({ children }) => <span>{children}</span>,
  h1: ({ children }) => <p className="font-semibold mb-2">{children}</p>,
  h2: ({ children }) => <p className="font-semibold mb-2">{children}</p>,
  h3: ({ children }) => <p className="font-semibold mb-2">{children}</p>,
}

export function ChatMessageText({ content }) {
  return <ReactMarkdown components={markdownComponents}>{withLineBreaks(content)}</ReactMarkdown>
}

export default ChatMessageText
